<template >
    <div class="card p-2 col-12 col-md-6 col-lg-4">

        <div class="card-img pb-2">
        <a :href="link" target="_blank">
            <span v-if="socicon" :class="getIconClass"></span><br/>
            <img v-if="imageLink" :src="imageLink" class="imageLink"><br/>
        </a>
        </div>
        <div class="card-box ">
            <a :href="link" target="_blank">
        <h4 class="card-title py-3 mbr-fonts-style display-5">{{ title }}</h4>
            </a>
        </div>
        
    </div>


</template>


<script>
export default {
    props: [
        "socicon", "title", "link", "imageLink"
    ],
    computed: {
        getIconClass() {
            let response = "mbr-iconfont  socicon socicon-large socicon-";
            return response + this.socicon
        }
    }
}
</script>

<style>

.socicon-large {
    font-size: 6em;
    margin: 0;
    padding: 0;   

}
.card-box {
    font-size: 1.5em;
    text-align: center;
}

.imageLink {
    max-width: 6em;
    max-height: 6em;
}
.card-img {
    min-height: 6em;
    margin: 0;
    padding: 0; 
    line-height: 0px;  

}

.card {
    background-color: #eee;
    border: 1px solid #ddd;
    margin: 5px;
    padding: 5px;
}
</style>